// src/store/productCategoryManagment/reducer.ts

import {
  FETCH_PRODUCT_CATEGORY_REQUEST,
  FETCH_PRODUCT_CATEGORY_SUCCESS,
  FETCH_PRODUCT_CATEGORY_FAILURE,
  ProductCategoryState,
  initialState,
  ProductCategoryActionTypes
} from './types';

const productCategoryReducer = (state = initialState, action: ProductCategoryActionTypes): ProductCategoryState => {
  switch (action.type) {
    case FETCH_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PRODUCT_CATEGORY_SUCCESS: {
      const categoryMap = new Map(state.categories);
      action.payload.categories.forEach(category => {
        categoryMap.set(category.id, category);
      });
      return {
        ...state,
        loading: false,
        categories: categoryMap,
        lastFetchTimestamp: action.payload.lastFetchTimestamp
      };
    }

    case FETCH_PRODUCT_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default productCategoryReducer;